import React from "react"
import styled from "@emotion/styled"
import { connect } from "react-redux";

import Ad from "./ad"

class Right extends React.PureComponent {
	constructor(props) {
    super(props);
    this.pre_ad2 = React.createRef();
		this.state = {
			ad2_docked: false
		}
  }

	componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
	handleScroll = () => {
		var docViewTop = window.scrollY;
		if (this.props.isDocked) {
			docViewTop += 36;
		}
		var elemTop = this.pre_ad2.current.offsetTop;
		this.setState({
			ad2_docked: docViewTop >= elemTop
		})

	};
	render() {
		const {isDocked} = this.props;
		return (
			<Wrapper isDocked={isDocked}>
				<div className="section ad1">
					<Ad
						freestarPlacementName="yaytext_siderail_atf"
						ezoic_placeholder_id="102"
						adsense_slot="2181527487"
						adsense_format="auto"
						/>
				</div>
				<div ref={this.pre_ad2} />
				<div className={`section ad2 ${this.state.ad2_docked ? 'docked' : '' }`}>
					<Ad
						freestarPlacementName="yaytext_siderail_atf_sticky"
						ezoic_placeholder_id="119"
						adsense_slot="3406034027"
						adsense_format="auto"
						/>
				</div>
			</Wrapper>
		);
	}
}

export default connect(state => ({
  isDocked: state.isDocked
}))(Right);

const Wrapper = styled("div")`
width: 310px;
min-height: 100%;
padding: 10px 5px;
position: absolute;
right: 0;
top: 0;
box-sizing: border-box;
overflow: hidden;
@media screen and (max-width: 1415px) {
	display: none;
}
.section {
	margin-bottom: 20px;
	min-width: 300px;
	background: rgb(96, 184, 195);
}
.ad1 {
	min-height: 600px;
}
.ad2 {
	min-height: 600px;
}
.section.docked {
	position: fixed;
	top:46px;
	right:5px;
}
`
